import {
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { TranslationService } from '@services/translation.service';
import { Subject } from 'rxjs';
import { availableLanguages } from 'translations';

@Component({
  selector: 'app-translation-button',
  templateUrl: 'translation-button.component.html',
  styleUrls: ['translation-button.component.scss'],
})
export class TranslationButtonComponent
  implements OnInit, OnChanges, OnDestroy
{
  private lifecycle = new Subject<void>();

  currLangCode: string = this.ts.getCurrentLanguageCode();
  visibleLangCode: string =
    this.currLangCode === availableLanguages.en
      ? availableLanguages.pt
      : availableLanguages.en;
  tooltip: string = this.getTooltip();

  constructor(public ts: TranslationService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {}

  ngOnDestroy(): void {
    this.lifecycle.next();
    this.lifecycle.complete();
  }

  getTooltip() {
    if (this.visibleLangCode === availableLanguages.en) {
      return 'ENGLISH';
    }

    return 'PORTUGUÊS';
  }

  onBtnClick() {
    if (this.currLangCode === availableLanguages.en) {
      this.ts.setCurrentLanguage(availableLanguages.pt);
      window.location.reload();
      return;
    }

    if (this.currLangCode === availableLanguages.pt) {
      this.ts.setCurrentLanguage(availableLanguages.en);
      window.location.reload();
      return;
    }
  }
}
